
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19","viewBox":"0 0 19 19"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/slider-horizontal"}},[_c('path',{attrs:{"d":"M14.25 5.541v7.917a9.46 9.46 0 01-.071 1.314c-.23 2.082-1.211 2.644-3.887 2.644H8.708c-2.676 0-3.658-.562-3.887-2.644a9.46 9.46 0 01-.071-1.314V5.541a9.46 9.46 0 01.071-1.314c.229-2.082 1.211-2.644 3.887-2.644h1.584c2.676 0 3.658.562 3.887 2.644a9.46 9.46 0 01.071 1.314z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M4.75 13.459a9.46 9.46 0 00.071 1.314c-.111.008-.214.008-.333.008h-.269c-2.106 0-2.636-.531-2.636-2.644V6.864c0-2.114.53-2.644 2.636-2.644h.269c.119 0 .222 0 .333.008a9.46 9.46 0 00-.071 1.314zM17.417 6.864v5.273c0 2.114-.53 2.644-2.636 2.644h-.269c-.119 0-.222 0-.333-.008a9.46 9.46 0 00.071-1.314V5.542a9.46 9.46 0 00-.071-1.314c.111-.008.214-.008.333-.008h.267c2.108 0 2.638.53 2.638 2.644z","opacity":".4"}})])])
          )
        }
      }
    